import { Card, Grid, Link as MuiLink, Skeleton, styled } from '@mui/material';

import { ApplicationLogo } from 'AppLayout/ApplicationLogo';
import { Colors } from 'Themes/colors';

namespace CardConsts {
  export const verticalPadding = '36px';
  export const horizontalPadding = '48px';
}

const defaultGridStyles = `
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledGrid = styled(Grid)`
  max-width: 968px;
  ${defaultGridStyles}
  margin: 10% auto;
`;

export const StyledCard = styled(Card)`
  && {
    position: relative;
    padding: ${CardConsts.verticalPadding} ${CardConsts.horizontalPadding};
  }
`;

export const StyledApplicationLogo = styled(ApplicationLogo)`
  position: absolute;
  width: 164px;
  right: ${CardConsts.horizontalPadding};
`;

export const StyledJoinCourseSkeleton = styled(Skeleton)`
  height: 350px !important;
  ${defaultGridStyles}
`;

const linkStyle = `
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: 100%;
  text-decoration-line: underline;
  white-space: nowrap;
  cursor: pointer;
  color: ${Colors.blue} !important;
  &:visited {
    color: ${Colors.blue} !important;
  }
`;

export const ButtonLink = styled(MuiLink)`
  ${linkStyle}
`;
